import React, {useEffect } from "react";
import { connect } from "react-redux";
import { Routes, Route, useLocation } from "react-router-dom";
import MasterRoutes from "./master";
import LayoutFull from "../Layouts/Layout";
import LoginLayout from "../Layouts/LoginLayout";
import Home from "../../containers/HomeContainer";
import Login from "../Login";
import Page404 from "../../components/utilities/404";
import { bindActionCreators } from "redux";
import AuthMiddleware from "../../reducers/auth/middleware";
import LogoutContainer from "../../containers/LogoutContainer";
import ResetContainer from "../../containers/modules/auth/ResetPassword";
import NewPassword from "../../containers/modules/auth/NewPassword";

import LoadingFullScreen from "../../components/layouts/LoadingFullScreen";
import AuthActions from "../../reducers/auth/actions";

import PrintRoutes from "./print";
import SalesRoutes from "./sales";
import UserRoutes from "./user";
import AccountingRoutes from "./Accounting";
import PurchasingRoutes from "./purchasing";
import LogRoutes from "./log";
import MutationRoutes from "./mutation";
import SettlementSalesRoute from "./settlement-sales";
import MutationDepositRoute from "./mutation-deposit";
import StockCardRoute from "./stock-card";
import WarehouseRoutes from "./warehouse";
import MarketingRoutes from "./marketing";
import ReportRoutes from "./report";
import HrRoutes from "./hr";
const mapStateToProps = ({ auth }) => ({
  isAuthenticated: auth.isAuthenticated,
  authUser: auth.authUser,
  onVerify: auth.onVerify,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      checkLogin: () => AuthMiddleware.checkLogin(),
      onVerifySet: (data) => AuthActions.onVerifySet(data),
    },
    dispatch
  );
};

export function App(props) {
  // const authUser={}
  const { authUser, isAuthenticated, onVerify } = props;
  let location = useLocation();

  useEffect(() => {
    let path = location.pathname;
    let split = path.split("/");
    if (split[1] != "new-password") {
      props.checkLogin();
    } else {
      props.onVerifySet(false);
    }
  }, []);
  if (onVerify) {
    return <LoadingFullScreen></LoadingFullScreen>;
  }
  return (
    <Routes>
      <Route path="logout" element={<LogoutContainer />} />
      {PrintRoutes(props)}
      <Route element={<LayoutFull></LayoutFull>} errorElement={<Page404 />}>
        <Route path="*" element={<Page404 />} />
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Home />} />
        {MasterRoutes(props)}
        {SalesRoutes(props)}
        {UserRoutes(props)}
        {AccountingRoutes(props)}
        {PurchasingRoutes(props)}
        {LogRoutes(props)}
        {MutationRoutes(props)}
        {StockCardRoute(props)}
        {SettlementSalesRoute(props)}
        {MutationDepositRoute(props)}
        {WarehouseRoutes(props)}
        {MarketingRoutes(props)}
        {ReportRoutes(props)}
        {HrRoutes(props)}
      </Route>

      <Route element={<LoginLayout />}>
        <Route path="/login" element={<Login />} errorElement={<Page404 />} />
        <Route
          path="/reset-password"
          element={<ResetContainer />}
          errorElement={<Page404 />}
        />
      </Route>
      <Route
        id={"resetpassword"}
        path="/new-password/:code"
        element={<NewPassword />}
        errorElement={<Page404 />}
      />
    </Routes>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
